import React, { FC } from 'react'
import { DepartmentsEnum } from '@moonpig/web-explore-types-graphql'
import { FiltersCarouselStickyWrapper } from '../FiltersCarousel/components'
import { QuickFilters } from '../QuickFilters/QuickFilters'
import { FiltersCarousel } from '../FiltersCarousel'

type FiltersBarProps = {
  departments: DepartmentsEnum[]
  withNbaFilters?: boolean
}

export const FiltersBar: FC<FiltersBarProps> = ({
  departments,
  withNbaFilters = true,
}) => (
  <>
    <FiltersCarouselStickyWrapper>
      <QuickFilters departments={departments} />
    </FiltersCarouselStickyWrapper>
    <FiltersCarousel withNbaFilters={withNbaFilters} />
  </>
)
